import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import {
  setSortFieldSuivi,
  setOrderSuivi,
  setCurrentPageSuivi,
  setValueSuivi,
  setStatutSuivi,
} from "../../store/actions";

//import components
import ReactPaginate from "react-paginate";
//redux

import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "../Investor/useDebounce";
import { useNavigate } from "react-router-dom";
import Config from "config";
function SuiviList() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [suiviData, setSuiviData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [dataToSend, setDataToSend] = useState("");
  const [signature, setSignature] = useState(false);
  const [wait, setWait] = useState(400);

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    window.location.reload();
  };
  const handleAction = async () => {
    console.log(dataToSend);
    toast.info("Demande en cours ...");
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${dataToSend?.controller}/${dataToSend?.action}?sauvegardes_attestation_id=${dataToSend?.params?.sauvegardes_attestation_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Request successful");
        const responseData = await response.json();
        toast.success(responseData.message);
        setSignature(true);
      } else {
        console.error("Request failed");
        const responseData = await response.json();
        console.log(responseData.message);
        toast.error(responseData.message);
        if (responseData && responseData.error) {
          const errors = responseData?.error;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      // toast.error("Une erreur s'est produite");
    }
  };

  console.log(signature);
  // Pagination

  const currentPage = useSelector(
    (state) => state.FiltreReservationSuivi.currentPage
  );
  const itemsPerPage = 20; // Limite d'affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = suiviData.slice(indexOfFirstItem, indexOfLastItem);
  //Recherche
  const value = useSelector((state) => state.FiltreReservationSuivi.value);
  const statut = useSelector((state) => state.FiltreReservationSuivi.statut);
  const debounceSearch = useDebounce(value, 500);
  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/reservations_suivis?page=${currentPage}&sort_by=${sortField}_${sortOrder}&key=${value}&statut_signature=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      const upData = newData;
      setSuiviData(upData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector(
    (state) => state.FiltreReservationSuivi.sortField
  );
  const order = useSelector((state) => state.FiltreReservationSuivi.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageSuivi(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldSuivi(accessor));
    dispatch(setOrderSuivi(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Mes reservations suivis | DOM COM";

  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      history(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, history]);
  //page change
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/reservations_suivis?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}&statut_signature=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageSuivi(currentPage));
    setSuiviData(getData);
  };
  // Filtre

  // Mettre à jour les paramètres de filtre et déclencher la fonction de filtrage avec débordement

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = suiviData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setSuiviData((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  // La fonction de filtrage reste inchangée, elle utilise les paramètres de filtre accumulés
  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/reservations_suivis?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}&statut_signature=${statut}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }

      //   if (!response.ok) {
      //     redirectToLoginPage = true;

      //     throw new Error("La réponse du réseau n'est pas valide");
      //   }

      const newData = await response.json();
      setSuiviData(newData);
      console.log(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    return (
      <>
        {!loading ? (
          <>
            {suiviData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueSuivi(e.target.value));
                          dispatch(setCurrentPageSuivi(1));
                          handleFilterChange(filter.accessor, value);
                        }}
                      />
                    </Col>
                  );
                case "statut_signature":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={statut}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setStatutSuivi(e.target.value)),
                            dispatch(setCurrentPageSuivi(1));
                          handleFilterChange(filter.accessor, statut);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/reservations_suivis?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}&statut_signature=${statut}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }

        const newData = await response.json();
        setSuiviData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, []);

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/reservations_suivis?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}&statut_signature=${statut}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }
        dispatch(setCurrentPageSuivi(1));
        const newData = await response.json();
        setSuiviData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    if (currentPage === 1) {
      handleFiltering();
    }
  }, [debounceSearch, statut, signature]);

  return (
    <React.Fragment>
      {/* <DeleteModal
       show={deleteModal}
       onDeleteClick={}
       onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Suivi des souscriptions en cours (
                      {loading ? "--" : suiviData?.total_records})
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      &nbsp; &nbsp;
                      {/* {/* <Link to="#!" className="btn btn-sm btn-light me-1">
                        <i className="mdi mdi-export-variant"></i>Exporter
                      </Link> */}{" "}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {suiviData?.headers?.map(
                                ({ label, accessor, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessor ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessor}
                                      onClick={
                                        sortable
                                          ? () => handleSortingChange(accessor)
                                          : null
                                      }
                                      className="text-nowrap"
                                      style={{
                                        cursor: sortable
                                          ? "pointer"
                                          : "default",
                                      }}
                                    >
                                      {label}
                                      {cl}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            <Modal isOpen={modal} toggle={toggleModal}>
                              <ModalHeader toggle={toggleModal}>
                                Action
                              </ModalHeader>
                              <ModalBody>
                                <p>{dataToSend?.confirm}</p>
                              </ModalBody>
                              <ModalFooter>
                                <Button
                                  style={{ backgroundColor: "#555B21" }}
                                  onClick={() => {
                                    handleAction(), toggleModal();
                                  }}
                                >
                                  Valider
                                </Button>
                                <Button color="secondary" onClick={toggleModal}>
                                  Fermer
                                </Button>
                              </ModalFooter>
                            </Modal>
                            {suiviData?.data?.map((rowData, rowIndex) => (
                              <tr key={rowIndex}>
                                {suiviData?.headers?.map(
                                  ({ label, accessor }) => (
                                    <>
                                      {label === "PME" ? (
                                        <td
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <a
                                            href={`${backUrl}/pmes/${rowData.pme_id}`}
                                          >
                                            <i className="bx bx-link"></i>
                                          </a>
                                          {rowData[accessor] || "——"}
                                        </td>
                                      ) : label === "Investisseur" ? (
                                        <td
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <a
                                            className="underline"
                                            style={{ color: "#555B21" }}
                                            href={`${backUrl}/investisseurs/${rowData.investisseur_id}`}
                                          >
                                            {rowData[accessor] || "——"}
                                          </a>
                                        </td>
                                      ) : typeof rowData[accessor] ===
                                        "number" ? (
                                        <td
                                          className={"text-end"}
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor].toLocaleString(
                                            "fr-FR",
                                            {
                                              style: "currency",
                                              currency: "EUR",
                                            }
                                          ) || "——"}
                                        </td>
                                      ) : rowData[accessor] ===
                                        "Aucune signature" ? (
                                        <td
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <span
                                            className="badge-soft-danger badge bg-secondary"
                                            style={{ fontSize: "100%" }}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] ===
                                        "Fichier signé" ? (
                                        <td
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <span
                                            className="badge-soft-success badge bg-secondary"
                                            style={{ fontSize: "100%" }}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : rowData[accessor] ===
                                        "Fichier en cours de signature" ? (
                                        <td
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          <span
                                            className="badge-soft-info badge bg-secondary"
                                            style={{ fontSize: "100%" }}
                                          >
                                            {rowData[accessor] || "——"}
                                          </span>
                                        </td>
                                      ) : typeof rowData[accessor] ===
                                        "object" ? (
                                        <td
                                          className={"text-center"}
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor]?.action ? (
                                            <>
                                              <button
                                                className="btn-sm btn-rounded btn"
                                                style={{
                                                  backgroundColor: "#555B21",
                                                  color: "white",
                                                }}
                                                onClick={() => {
                                                  toggleModal(),
                                                    setDataToSend(
                                                      rowData[accessor]
                                                    );
                                                }}
                                              >
                                                Relancer la signature
                                                <i className="bx bx-pencil " />
                                              </button>
                                            </>
                                          ) : (
                                            <td
                                              className={"text-center"}
                                              style={{
                                                // width: "33.33%",
                                                padding: "12px",
                                                fontFamily: "Sans-Serif",
                                              }}
                                              key={`${rowIndex}-${accessor}`}
                                            >
                                              {rowData[accessor] || "——"}
                                            </td>
                                          )}
                                        </td>
                                      ) : (
                                        <td
                                          className={"text-center"}
                                          style={{
                                            // width: "33.33%",
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                          key={`${rowIndex}-${accessor}`}
                                        >
                                          {rowData[accessor] || "——"}
                                        </td>
                                      )}
                                    </>
                                  )
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={wait} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={suiviData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default SuiviList;
